import { render, staticRenderFns } from "./localesAdd.vue?vue&type=template&id=6b373452"
import script from "./localesAdd.vue?vue&type=script&lang=js"
export * from "./localesAdd.vue?vue&type=script&lang=js"
import style0 from "./localesAdd.vue?vue&type=style&index=0&id=6b373452&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports